import type { GoodType } from "@cwb/core";

/**
 * The two goods, as marks rather than words.
 *
 * Deliberately the same silhouettes `GarrisonRenderer` draws on the map: a
 * player who learns what a shape means on a province must not have to learn it
 * again in the order book. The geometry here is authored in a 16-unit box and
 * scaled by the font size around it, so an icon grows with the row it sits in.
 *
 * `currentColor` throughout, so a row tints its icon by tinting its text — the
 * good's colour, or red when the row is refused.
 */
export function GoodIcon({ good, size = 16 }: { good: GoodType; size?: number }) {
  return (
    <svg
      className="good-icon"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      {good === "weapons" ? (
        // A rifle pointing right: barrel, receiver, stock dropping back, magazine.
        <>
          <rect x="7" y="4.2" width="7.4" height="1.7" />
          <rect x="3.6" y="5.9" width="8" height="2.6" />
          <path d="M3.6 8.5 L1.2 11.8 L6.4 8.5 Z" />
          <rect x="7.4" y="8.5" width="1.8" height="3.2" />
        </>
      ) : (
        // Ore: a cut gem, unchanged — the one mark that was already reading.
        <>
          <path d="M8 2.4 L13 7.4 L3 7.4 Z" />
          <path d="M3 7.4 L13 7.4 L8 13.6 Z" />
        </>
      )}
    </svg>
  );
}

/**
 * A mine, for the places that name a resource facility rather than the ore it
 * yields. Same pickaxe the map draws, for the same reason.
 */
export function MineIcon({ size = 16 }: { size?: number }) {
  return (
    <svg
      className="good-icon"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M3.1 13.6 L4.6 13.6 L12.6 4.8 L11.1 4.8 Z" />
      <path d="M5.2 2.4 L13.8 6.5 L12.7 7.8 L7.6 5.4 L2.9 6.3 L2.9 4.4 Z" />
    </svg>
  );
}
